export default __webpack_public_path__ + "static/media/photo--sm--19.eef8e050.jpg";